import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  selector: "app-logo",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./logo.component.html",
  styleUrl: "./logo.component.css",
})
export class LogoComponent {
  @Input()
  type: "blue" | "white" | "yellow" | "nsgo" = "white";
}
